module.exports = __webpack_public_path__ + "static/media/youtube_logo.ecb218b2.svg";